import {APP_PREV_ROUTE} from '../store/types'

const COLON_ESCAPE_STR = '-_-';
const COLON_REGEXP = new RegExp(/:/, 'g');
const COLON_UNESCAPE_REGEXP = new RegExp(COLON_ESCAPE_STR, 'g');

const RouteParamPlugin = {
  install: function (Vue) {
    Vue.prototype.$getRouteLevel = function (route) {
      const meta = route.meta || {};
      return meta.level || 0;
    };

    Vue.prototype.$encodeRouteParam = function (rawValue) {
      if (rawValue === undefined || rawValue == null) {
        return undefined;
      }

      const escapedColon = typeof rawValue === 'number' ? rawValue : rawValue.replace(COLON_REGEXP, COLON_ESCAPE_STR);
      return encodeURIComponent(escapedColon);
    };

    Vue.prototype.$getPreviousRoute = function () {
      let path = this.$store.getters[APP_PREV_ROUTE];

      if (!path) {
        const fallBack = this.$route.meta.backFallBack;
        if (fallBack instanceof Function) {
          path = fallBack.bind(this)();
        } else if (typeof fallBack === 'string') {
          path = {name: fallBack};
        } else {
          path = '/'
        }
      }

      let route = null;
      if (typeof path === 'string') {
        route = {path, params: {}};
      } else {
        route = {
          name: path.name,
          params: path.params || {},
          query: path.query || {}
        };
      }

      return route;
    };

    Vue.prototype.$getRouteParam = function (paramName, isQueryParam = false) {
      const rawValue = this.$route[isQueryParam ? 'query' : 'params'][paramName];

      if (rawValue === undefined || rawValue == null) {
        return null;
      }

      const decoded = decodeURIComponent(rawValue);
      return decoded.replace(COLON_UNESCAPE_REGEXP, ':');
    };

    Vue.prototype.$goBack = function (params = {}) {
      const route = this.$getPreviousRoute();

      if (Object.keys(params).length > 0) {
        route.params = {
          ...route.params,
          ...params,
        };
      }

      this.$router.replace(route);
    };
  }
};

export default RouteParamPlugin;